module.exports = __webpack_public_path__ + "img/bg6.90d22799.png";